// extracted by mini-css-extract-plugin
export var errorsContainer = "_ql-1";
export var link = "_ql-0";